import React from 'react';
import { Link } from 'react-router-dom';

const ImpressumPage = () => {
    const s = {
        container: { padding: '20px', color: '#aaa', maxWidth: '600px', margin: '0 auto' },
        backLink: { color: '#007BFF', textDecoration: 'none', fontSize: '1.2em' }
    };
    return (
        <div style={s.container}>
            <Link to="/" style={s.backLink}>&larr; Back to Map</Link>
            <h1>Legal Notice (Impressum)</h1>
            <p>Information pursuant to § 5 TMG</p>
            <p><strong>[DEIN NAME/FIRMA]</strong><br/>[DEINE STRASSE NR.]<br/>[DEINE PLZ STADT]<br/>Germany</p>
            <h2>Contact:</h2>
            <p>E-Mail: [DEINE E-MAIL]</p>
            <h2>Disclaimer:</h2>
            <p>This service is provided "as is", without warranty of any kind. By using this service, you agree that you are solely responsible for your own actions, safety, and any consequences that may arise from meeting others. We are not responsible for the content of external links or the actions of any users.</p>
        </div>
    );
};
export default ImpressumPage;
